// Modules
import { forwardRef, memo, useCallback, useState } from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { useTranslation } from 'react-i18next'

// Languages
import { LN_BTN_CLICK_TO_COPY, LN_USER_COPIED_TEXT_TO_CLIPBOARD_MESSAGE } from 'locales/constants'

// Components
import { TextSm } from 'components/Typography/TextBase'

// Hooks
import useCurrentColorTheme from 'hooks/useCurrentColorTheme'

// UI
import { Box, Button, Text, Tooltip } from '@chakra-ui/react'

const CopyBtnLikeInputWrapper = ({ value, tooltipTitle = LN_BTN_CLICK_TO_COPY, ...args }) => {
  const { t } = useTranslation()

  return (
    <Tooltip label={t(tooltipTitle)} aria-label={tooltipTitle?.toLowerCase()}>
      <CopyBtnLikeInput value={value} {...args} />
    </Tooltip>
  )
}

export default memo(CopyBtnLikeInputWrapper)

const CopyBtnLikeInput = forwardRef(({ value, ...args }, ref) => {
  const { isLightTheme } = useCurrentColorTheme()
  const { t } = useTranslation()

  const [copyStatus, setCopyStatus] = useState(false)

  const onCopyText = useCallback(() => {
    setCopyStatus(true)
    setTimeout(() => setCopyStatus(false), 2000)
  }, [setCopyStatus])

  return (
    <Box position="relative" w="100%" mb="4">
      <CopyToClipboard text={value} onCopy={onCopyText}>
        <Button
          ref={ref}
          bg={isLightTheme ? 'gray.100' : 'whiteAlpha.50'}
          _hover={{
            bg: isLightTheme ? 'gray.200' : 'whiteAlpha.100',
          }}
          w="100%"
          justifyContent="start"
          {...args}
        >
          <Text fontSize="md" fontWeight={400} overflow="hidden">
            {value}
          </Text>
        </Button>
      </CopyToClipboard>

      {copyStatus && (
        <TextSm
          pos="absolute"
          bottom="-1.5em"   // подвинуть чуть ниже кнопки
          left="0"
          color="green.400"
        >
          {t(LN_USER_COPIED_TEXT_TO_CLIPBOARD_MESSAGE)}
        </TextSm>
      )}
    </Box>

  )
})

CopyBtnLikeInput.displayName = 'CopyBtnLikeInput'
